import placeholder2 from "../assets/images/arts/3.jpg";
import placeholder3 from "../assets/images/arts/4.jpg";

const RoadMAP = () => {
    const dataArray = [
        {
            title: "10%",
            bodyText:
                <p>Early members and contributors to the discord & socials will be rewarded with giveaways. The first 5000 members of discord will be granted the “OG” role. Get in quick!</p>
        },
        {
            title: "20%",
            bodyText:
                <p>5 lucky minters will be drawn to win $10,000 each. </p>
        },
        {
            title: "40%",
            bodyText:
                <p>
                    1 of the Executive Apes will be given away to one lucky minter + $50,000.
                </p>
        },
        {
            title: "60%",
            bodyText:
                <p>
                    $100,000 will be donated to The Fred Hollows Foundation.
                </p>
        },
        {
            title: "80%",
            bodyText:
                <p>

                    4 lucky minters will be drawn to win $50,000 each.
                </p>
        },
        {
            title: "100%",
            bodyText:
                <p>
                    $150,000 will be donated to The Fred Hollows Foundation. Upon complete sell out we will begin to develop our token minting and breeding function. Winners of all giveaways will receive their prizes.
                </p>
        }
    ];
    return (
        <section id="roadmap" className="roadmap-main">
            <div className="main-head-for-roadmaps sec-heading-wrapper">
                <h3 className="sec-heading">Roadmap</h3>
            </div>
            <div className="container">
                <div className="rd-timeline">
                    <div className="timeline-left">
                        {dataArray.map((data, index) => {
                            return (
                                <div key={index} className="container-map">
                                    <div className="content" data-aos="fade-up">
                                        <h3 className="roadmap-section-heading">{data.title}</h3>
                                        {data.bodyText}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                    <div className="timeline-right">
                        <img loading="lazy" data-aos="fade-down" src={placeholder2} alt="Business Ape Club" />
                        <img loading="lazy" data-aos="fade-up" src={placeholder3} alt="Business Ape Club" />
                    </div>
                </div>
            </div>
        </section>
    )
};





export default RoadMAP
